import { render } from "./BankRecTableHeader.vue?vue&type=template&id=93e74600"
import script from "./BankRecTableHeader.vue?vue&type=script&lang=js"
export * from "./BankRecTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__